import { observer } from 'mobx-react-lite';
import PreviewButtonContainerElement from './PreviewButtonContainerElement';
import type { PreviewButtonContainerElementProps } from './types';

export type { PreviewButtonContainerElementProps };
export default observer(PreviewButtonContainerElement);
